// export { CoreModule } from './core/core.module';
export { SweetAlertService } from './sweet-alert-service';
export { PWAService } from './pwa.service';
